import React from 'react';
import { inr } from './portfolioHealthCheckApi';

export default function PortfolioSummary({ review, onReload, onRequestFetch, isClient = false }) {
  const { totals, reconciliation: rc, buckets, rows, eligibleFunds } = review;

  const matchedRows = rows ? rows.filter((r) => r.bucket === 'matched') : [];
  const eligibleValue = matchedRows.reduce((sum, r) => sum + (r.currentValue || 0), 0);

  const notComparedRows = rows ? rows.filter((r) => r.bucket === 'excluded_by_type' || r.bucket === 'left_out') : [];
  const notComparedValue = notComparedRows.reduce((sum, r) => sum + (r.currentValue || 0), 0);

  const statementTotal = rc.statementTotal || totals.knownCurrentValue;

  return (
    <section className="phc-card phc-summary-card" aria-labelledby="phc-inv-h">
      <div className="phc-summary-header">
        <div>
          <h2 id="phc-inv-h" className="phc-summary-title">
            Your file: {totals.holdings} holdings across {totals.distinctSchemes} scheme{totals.distinctSchemes === 1 ? '' : 's'}
          </h2>
          <p className="phc-summary-subtitle">
            From 1 table · 0 heading, personal-detail, total or note lines skipped (not shown) - total {inr(statementTotal)}
          </p>
        </div>
        {!isClient && onReload && (
          <button type="button" className="phc-link phc-start-again-btn" onClick={onReload}>
            Start again
          </button>
        )}
      </div>

      <div className="phc-summary-banner">
        <div className="phc-banner-title">
          <span className="phc-checkmark-icon">✓</span> Statement total accounted for · overlap covers the compared funds only
        </div>
        <div className="phc-banner-detail">
          Statement total {inr(statementTotal)} = {inr(eligibleValue)} eligible for comparison (holdings checked on Analyse) ({eligibleFunds}) + {inr(notComparedValue)} not compared (fund type) ({notComparedRows.length})
        </div>
      </div>

      <div className="phc-summary-file-box">
        <div className="phc-file-row">
          <span className="phc-file-name">CAS_Portfolio_Statement.pdf</span>
          {!isClient && (
            <div className="phc-file-actions">
              {onRequestFetch && (
                <button type="button" className="phc-link" onClick={onRequestFetch}>Replace</button>
              )}
              <button type="button" className="phc-link" onClick={onReload}>Remove</button>
            </div>
          )}
        </div>
        <p className="phc-file-subtext">
          {totals.holdings} lines found · {eligibleFunds} eligible lines · {buckets.excluded_by_type?.count || 0} other fund type (kept in your total) · 0 need you · 0 duplicates · {buckets.left_out?.count || 0} left out · Adds up to the statement total
        </p>
      </div>

      <div className="phc-summary-metrics-grid">
        <div className="phc-metric-col">
          <span className="phc-metric-label">Matched</span>
          <strong className="phc-metric-val">{buckets.matched?.count || 0}</strong>
          <span className="phc-metric-desc">holdings in {eligibleFunds} eligible funds</span>
        </div>
        <div className="phc-metric-col">
          <span className="phc-metric-label">Identity to confirm</span>
          <strong className="phc-metric-val">{buckets.identity_to_confirm?.count || 0}</strong>
        </div>
        <div className="phc-metric-col">
          <span className="phc-metric-label">Value to confirm</span>
          <strong className="phc-metric-val">{buckets.value_to_confirm?.count || 0}</strong>
        </div>
        <div className="phc-metric-col">
          <span className="phc-metric-label">Excluded by fund type</span>
          <strong className="phc-metric-val">{buckets.excluded_by_type?.count || 0}</strong>
        </div>
        <div className="phc-metric-col">
          <span className="phc-metric-label">Left out</span>
          <strong className="phc-metric-val">{buckets.left_out?.count || 0}</strong>
        </div>
      </div>
    </section>
  );
}
